module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ctaTradingView":"Quotes by <a href=\u0027https://www.tradingview.com/\u0027 style=\u0027font-size: 12px\u0027 target=\u0027_blank\u0027>TradingView</a>"},"es":{"ctaTradingView":"Precios por <a href=\u0027https://www.tradingview.com/\u0027 style=\u0027font-size: 12px\u0027 target=\u0027_blank\u0027>TradingView</a>"}}')
  delete Component.options._Ctor
}
